import { Builder } from '@builder.io/react'
import React from 'react'

import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'

enum ButtonAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export interface CTAFiveProps {
  backgroundColor: string
  buttonAlignment: ButtonAlignment
  CTAButton: LinkButtonProp
  secondaryCTA: boolean
}

const CTAFive = ({ backgroundColor, buttonAlignment, CTAButton, secondaryCTA = false }: CTAFiveProps) => {
  const getButtonAlignment = () => {
    let alignment = 'flex-start'
    switch (buttonAlignment) {
      case ButtonAlignment.Center: {
        alignment = 'flex justify-center mx-auto'
        break
      }
      case ButtonAlignment.Right: {
        alignment = 'flex-end'
        break
      }
      default: {
        alignment = 'flex-start'
        break
      }
    }
    return alignment
  }

  const alignment = getButtonAlignment()

  return (
    <div className="bg-white w-full" style={{ backgroundColor }}>
      <div className="mx-auto max-w-7xl py-2 px-4 sm:px-4 md:py-4 lg:px-4 ">
        <div className={`flex w-auto mx-auto ${alignment}`}>
          <div className="inline-flex w-auto rounded-full">
            {!secondaryCTA ? (
              <LinkButton
                buttonColor={CTAButton?.buttonColor}
                buttonText={`${CTAButton?.buttonText} `}
                loggedInButtonText={CTAButton?.loggedInButtonText}
                buttonTextColor={CTAButton?.buttonTextColor}
                buttonUrl={CTAButton?.buttonUrl}
                loggedInButtonUrl={CTAButton?.loggedInButtonUrl}
                isLink={CTAButton?.isLink}
                classList={
                  'w-full md:w-fit inline-flex items-center justify-center px-5 py-3 border border-transparent text-lg font-medium rounded-full text-white'
                }
              />
            ) : (
              <LinkButton
                buttonColor={CTAButton?.buttonColor}
                buttonText={`${CTAButton?.buttonText} `}
                loggedInButtonText={CTAButton?.loggedInButtonText}
                buttonTextColor={CTAButton?.buttonTextColor}
                buttonUrl={CTAButton?.buttonUrl}
                loggedInButtonUrl={CTAButton?.loggedInButtonUrl}
                isLink={CTAButton?.isLink}
                classList={
                  'w-full md:w-fit inline-flex items-center justify-center px-5 py-3 border border-transparent text-lg font-medium rounded-full text-white border-2 border-primary shadow-none'
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTAFive

Builder.registerComponent(CTAFive, {
  name: 'CTAFive',
  inputs: [
    {
      name: 'buttonAlignment',
      type: 'string',
      enum: ['left', 'right', 'center'],
      defaultValue: 'center'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'CTAButton'
    },
    {
      name: 'secondaryCTA',
      type: 'boolean',
      defaultValue: 'false'
    }
  ]
})

export const CTAFiveRegisterProps = {
  name: 'buttonProps',
  type: 'object',
  defaultValue: {
    buttonAlignment: 'center',
    backgroundColor: 'lightblue',
    CTAButton: LinkButtonRegisterProps
  },
  subFields: [
    {
      name: 'buttonAlignment',
      type: 'string',
      enum: ['left', 'right', 'center'],
      defaultValue: 'center'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'CTAButton'
    }
  ]
}
